import {
  GET_STANDINGS_REQUEST_START,
  GET_STANDINGS_REQUEST_SUCCESS,
  GET_STANDINGS_REQUEST_ERROR
} from 'actions/pages/standings';
import {
  createRequestReducers,
  requestReducerStart,
  requestReducerSuccess,
  requestReducerError
} from 'util/reducers';

function getInitialState() {
  return {
    requests: createRequestReducers([
      'getStandings'
    ]),
    standings: null
  }
}

export default function (state = getInitialState(), action) {
  const { type, standings, error } = action;

  switch (type) {
    case GET_STANDINGS_REQUEST_START:
      return {
        ...state,
        requests: requestReducerStart(state.requests, 'getStandings'),
      };

    case GET_STANDINGS_REQUEST_SUCCESS:
      return {
        ...state,
        requests: requestReducerSuccess(state.requests, 'getStandings'),
        standings
      };

    case GET_STANDINGS_REQUEST_ERROR:
      return {
        ...state,
        requests: requestReducerError(state.requests, 'getStandings', error),
        error
      };

    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/reducers/pages/standings.js